import React from "react";
import savedStyles from "./Settings.module.scss";
import { Link, useNavigate, useParams } from "react-router";
import Icon from "../../components/Icon";
import RemoveDialog from "./RemoveDialog";
import useCardsState from "../../hooks/useCardsState";
import { useTranslation } from "react-i18next";

const RemoveCard = () => {
    const { deleteByMaskedCLN, getByCardMaskedCLN } = useCardsState();
    const { maskedCLN } = useParams();
    const card = getByCardMaskedCLN(maskedCLN);
    const navigateTo = useNavigate();

    const { t } = useTranslation();

    return (
        <div className={savedStyles._container}>
            <div className={savedStyles.wrapper}>
                <Link to={"/settings"} className={`d-flex-center gap-3 ${savedStyles.backLink}`}>
                    <Icon.LeftChevron size={12} />
                    {t("settings.removeCard.back")}
                </Link>
                <h1>{t("settings.removeCard.title")}</h1>
                {card && (
                    <RemoveDialog
                        type={"card"}
                        title={`${card.name}`}
                        onCancel={() => {
                            navigateTo("/settings");
                        }}
                        onSubmit={() => {
                            deleteByMaskedCLN(maskedCLN);
                            navigateTo("/settings");
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default RemoveCard;
